import TemplateView from '../../../TemplateView'
import InputField from '../../../components/InputField'
import SimpleListMenuButton from '../../../SimpleListMenuButton'
import messageResource from '../../../messageResource'
import _ from 'underscore'

export default class AddressForm extends TemplateView {
    constructor({
        fieldsChangeCallback = () => {},
        menuPositionParams = {},
    } = {}) {
        super()

        this.callbacks = {
            fieldsChangeCallback,
        }

        this.state = {
            address: '',
            city: '',
            zip: '',
            country: '',
            state: '',
            countries: [],
            statesByCountry: {},
        }

        this.params = {
            menuPositionParams,
        }

        this.onStatePropertyChanged('address', (address) => this._setValueIfChanged(this.addressField, address))
        this.onStatePropertyChanged('city', (city) => this._setValueIfChanged(this.cityField, city))
        this.onStatePropertyChanged('zip', (zip) => this._setValueIfChanged(this.indexField, zip))

        this.onAnyStatePropertyChanged(['country', 'countries'], () => {
            this.countriesListSelector.setItems(this.state.countries, null)
            const countryItem = this.state.countries.find((item) => item.code === this.state.country)
            this.countriesListSelector.setSelectedItem(countryItem)
            const hasStates = !!this.state.statesByCountry[this.state.country]
            this.statesListSelector.toggle(hasStates)
            this.stateField.toggle(!hasStates)
            this.statesListSelector.setItems(hasStates ? this.state.statesByCountry[this.state.country] : [], null)
        })

        this.onAnyStatePropertyChanged(['state', 'country'], () => {
            if (this.state.country && this.state.statesByCountry[this.state.country]) {
                this.statesListSelector.setSelectedItem(this.state.state)
            } else {
                this._setValueIfChanged(this.stateField, this.state.state)
            }
        })
    }

    templateHtml() {
        return `<div class="addressForm">
                    <div class="addressFieldContainer field"/>
                    <div class = "shortFieldsContainer">
                        <div class="cityFieldContainer field"/>
                        <div class="indexFieldContainer field"/>
                        <div class="countryFieldContainer field"/>
                        <div class="stateFieldContainer field"/>
                    </div>
                </div>`
    }

    afterRender() {
        this.addressField = new InputField({
            maxLength: 255,
            additionalClass: 'addressInput',
            placeholder: messageResource.getMessage('licenses.address_form.placeholders.address'),
            onChange: (address) => this.callbacks.fieldsChangeCallback({address}),
        }).init(this.find('.addressFieldContainer'))

        this.cityField = new InputField({
            maxLength: 255,
            additionalClass: 'addressFormInput',
            placeholder: messageResource.getMessage('licenses.address_form.placeholders.city'),
            onChange: (city) => this.callbacks.fieldsChangeCallback({city}),
        }).init(this.find('.cityFieldContainer'))

        this.indexField = new InputField({
            maxLength: 45,
            additionalClass: 'addressFormInput',
            placeholder: messageResource.getMessage('licenses.address_form.placeholders.index'),
            onChange: (zip) => this.callbacks.fieldsChangeCallback({zip}),
        }).init(this.find('.indexFieldContainer'))

        this.countriesListSelector = new SimpleListMenuButton({
            extraClass: 'addressFormList',
            itemHeight: 32,
            emptySelectionMessageKey: 'licenses.address_form.country.empty_selection',
            itemHtmlCallback: (countryItem) => countryItem.name,
            onSelect: (countryItem) => this.callbacks.fieldsChangeCallback({
                country: countryItem.code,
                state: '',
            }),
            menuPositionParams: this.params.menuPositionParams,
        }).init(this.find('.countryFieldContainer'))

        this.stateField = new InputField({
            maxLength: 255,
            additionalClass: 'addressFormInput',
            placeholder: messageResource.getMessage('licenses.address_form.placeholders.state'),
            onChange: (state) => this.callbacks.fieldsChangeCallback({state})
        }).init(this.find('.stateFieldContainer'))

        this.statesListSelector = new SimpleListMenuButton({
            extraClass: 'addressFormList',
            itemHeight: 32,
            emptySelectionMessageKey: 'licenses.address_form.state.empty_selection',
            itemHtmlCallback: (state) => state,
            onSelect: (state) => this.callbacks.fieldsChangeCallback({state}),
            menuPositionParams: this.params.menuPositionParams,
        }).init(this.find('.stateFieldContainer'))
        this.statesListSelector.hide()
    }


    _setValueIfChanged(field, value) {
        if (field.getValue() !== value) {
            field.setValue(_.escape(value))
        }
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/AddressForm.js